// utils
import React from "react";
import { useMatch } from "react-router-dom";

// custom utils
import { getCurrentLanguage, getUrlPrefix, LANGUAGES } from "../../../utils/langUtils";

// translations (shared with MARS tile on GRANTS page)
import translation_cs from "../components/grants-mars/lang/cs.json";
import translation_en from "../components/grants-mars/lang/en.json";
import translation_de from "../components/grants-mars/lang/de.json";

// components
import GrantDetail from "../components/grant-detail/grant-detail";

// files
import eu_banner from "../../../files/images/pages/grants/eu_mpo_cofinanced_banner_cs.webp";

/**
 * GRANTS / MARS page
 * full text of MARS grant project
 * @returns HTML element for MARS grant page
 */
export default function Index() {

    const match = useMatch("/:lang/*");
    let lang = (match && match.params.lang) ? match.params.lang : "";
    let translation = translation_cs;

    let language = getCurrentLanguage(lang);
    switch (language) {
        case LANGUAGES.Czech:
            translation = translation_cs;
            break;
        case LANGUAGES.English:
            translation = translation_en;
            break;
        case LANGUAGES.German:
            translation = translation_de;
            break;
    }

    return (
        <>
            <div className="fade-in-750">
                <GrantDetail
                    header={translation.header}
                    info={[
                        translation.info.programme,
                        translation.info.call,
                        translation.info.registration,
                        translation.info.recipient,
                    ]}
                    paragraphs={translation.detail.paragraphs}
                    cofinancedNote={translation.cofinanced_note}
                    bannerSrc={eu_banner}
                    bannerAlt={translation.alt.eu_banner}
                    btnBackText={translation.detail.btn_back}
                    btnBackUrl={getUrlPrefix(language) + "grants"}
                />
            </div>
        </>
    );
}
